﻿(function (d, ns) {
  ns.initSlimStickyHeader = function () {
    const header = d.querySelector('.header--sticky');

    if (!header) {
      return;
    }

    if (window.pageYOffset > 0) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 0) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  };

  d.addEventListener('DOMContentLoaded', function () {
    ns.initSlimStickyHeader();
  });
})(document, Crafted.Utilities);